<template>
  <b-container class="progressbar-container p-0">
    <b-card>
      <b-row class="text-center ">
        <b-col
          class="justify-content-center"
          md="3"
          cols="3"
        >
          <feather-icon
            :class="classFirstField"
            size="38"
            icon="CheckSquareIcon"
          />
          <b-alert
            style="width: 8rem !important;"
            show
            :variant="variantFirstField"
          >
            Link Gerado
          </b-alert>
        </b-col>
        <b-col
          md="3"
          cols="3"
        >
          <feather-icon
            :class="classSecondField"
            size="38"
            icon="EditIcon"
          />
          <b-alert
            :style="`width: 9rem !important; background:${colorFilledAlert} !important; color: ${colorFilledText} !important`"
            show
          >
            Link Preenchido
          </b-alert>
        </b-col>
        <b-col
          md="3"
          cols="3"
        >
          <feather-icon
            :class="classThirdField"
            size="38"
            variant="success"
            icon="AlertCircleIcon"
          />
          <b-alert
            style="width: 6rem !important;"
            show
            :variant="variantThirdField"
          >
            Revisão
          </b-alert>
        </b-col>
        <b-col
          md="3"
          cols="3"
        >
          <feather-icon
            :style="styleFourthField"
            size="38"
            style="color: #22bb33;"
            :icon="status.lastProgressBarItemIcon"
          />
          <b-alert
            :style="`width: ${status.size}rem !important;`"
            :variant="variantFourthField"
            show
          >
            {{ status.lastProgressBarItemText }}
          </b-alert>
        </b-col>
      </b-row>
      <b-progress
        :animated="false"
        :value="status.progressBarWidth"
        variant="primary"
      />
    </b-card>
  </b-container>
</template>

<script>
import {
  BCard,
  BContainer,
  BAlert,
  BRow,
  BCol,
  BProgress,
} from 'bootstrap-vue'

const { statusObjectProgressBar } = require('@/information/detailsTransaction')

export default {
  components: {
    BCard,
    BContainer,
    BAlert,
    BRow,
    BCol,
    BProgress,
  },

  props: {
    statusId: {
      type: Number,
      default: () => 1,
    },
  },

  data() {
    return {
      variantFirstField: 'secondary',
      variantThirdField: 'secondary',
      variantFourthField: 'secondary',

      classFirstField: '',
      classSecondField: '',
      classThirdField: '',

      colorFilledAlert: 'rgba(130, 134, 139, 0.12)',
      colorFilledText: '#82868b',

      styleFourthField: 'color: #82868b !important',
    }
  },

  async created() {
    await this.handleDoObject()
    this.handleProgressBar()
  },

  methods: {
    handleProgressBar() {
      if (this.status.progressBarWidth >= 10) {
        this.variantFirstField = 'info'
        this.classFirstField = 'progressbar-generate-color'
      }
      if (this.status.progressBarWidth >= 28) {
        this.classSecondField = 'progressbar-filled-color'
        this.colorFilledAlert = 'rgba(18, 70, 128, 0.12)'
        this.colorFilledText = 'rgba(18, 70, 128)'
      }
      if (this.status.progressBarWidth >= 50) {
        this.variantThirdField = 'warning'
        this.classThirdField = 'progressbar-review-color'
      }
      if (this.status.progressBarWidth >= 80) {
        this.variantFourthField = this.status.lastProgressBarItemVariant
        this.colorStatusIcon = this.status.color
        this.styleFourthField = `color: ${this.status.color} !important`
      }
    },

    handleDoObject() {
      this.status = statusObjectProgressBar[this.statusId]
    },
  },
}

</script>

<style lang="scss" scoped>
  @import "@core/scss/base/components/progress-bar.scss";
</style>
